import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination, Navigation } from "swiper/modules";

import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";

import { Box } from "@mui/material";

interface CardSliderProps {
  componentItems: React.ReactNode[];
}

const CardSlider: React.FC<CardSliderProps> = ({ componentItems }) => {
  return (
    <Box
      sx={{
        width: "100%",
        "& .swiper-pagination-bullet-active": {
          backgroundColor: "#E62B16 !important",
        },
        "& .swiper-pagination": {
          position: "relative",
          marginTop: "15px",
        },
        "& .swiper-button-next, & .swiper-button-prev": {
          color: "#9e9e9e",
          opacity: 0,
          transition: "all 0.3s ease",
          "--swiper-navigation-size": "24px",
        },
        "&:hover .swiper-button-next, &:hover .swiper-button-prev": {
          opacity: 0.7,
        },
        "& .swiper-button-next:hover, & .swiper-button-prev:hover": {
          opacity: 1,
          color: "#616161",
        },
      }}
    >
      <Swiper
        modules={[Autoplay, Pagination, Navigation]}
        spaceBetween={0}
        slidesPerView={1}
        autoHeight={true}
        navigation={true}
        autoplay={{
          delay: 8000,
          pauseOnMouseEnter: true,
          disableOnInteraction: false,
        }}
        pagination={{
          clickable: true,
        }}
        grabCursor={true}
      >
        {componentItems.map((item, index) => (
          <SwiperSlide key={index}>{item}</SwiperSlide>
        ))}
      </Swiper>
    </Box>
  );
};

export default CardSlider;
